<div
  class="minimized-player-container"
  *ngIf="cs.isBrowser && isMinimized && currentMusic"
>
  <audio
    #audioPlayer
    class="audio-player"
    [src]="currentMusic?.audioUrl"
    (loadedmetadata)="onAudioLoadedMetadata()"
    (loadstart)="onAudioLoadStart()"
    (error)="onAudioError()"
    (timeupdate)="onAudioTimeUpdate()"
    (play)="onAudioPlay()"
    (pause)="onAudioPause()"
    (ended)="onAudioEnded()"
    (volumechange)="onAudioVolumeChange()"
    (ratechange)="onAudioRateChange()"
    *ngIf="(!isLocked || currentMusic?.canPreview) && isMinimized"
  ></audio>

  <!-- Desktop Minimized View -->
  <div class="minimized-player-desktop" *ngIf="!isMobile">
    <button class="close-button" (click)="closePlayer()">
      <span>✕</span>
    </button>

    <div class="album-art-container">
      <img
        *ngIf="currentMusic?.previewImageUrl"
        [src]="currentMusic?.previewImageUrl"
        [alt]="currentMusic?.songTitle"
        class="album-art"
        appDisableRightClick
        appMobileOptimization
        [originalUrl]="currentMusic?.previewImageUrl"
        [format]="'webp'"
        loading="lazy"
        decoding="async"
      />
      <div
        class="skeleton-thumbnail album-art"
        *ngIf="!currentMusic?.previewImageUrl"
      >
        <div class="song-audio-icon">
          <em class="icon-litemusic-node-2"></em>
        </div>
      </div>
      <div class="lock-overlay" *ngIf="isLocked">
        <em class="icon-lock cursor-pointer" (click)="maximizeModal()"></em>
      </div>
    </div>

    <div class="track-info">
      <div class="track-title">{{ currentMusic?.songTitle }}</div>
      <span class="track-date" *ngIf="currentMusic?.albumTitle">
        {{ currentMusic?.albumTitle }}
      </span>
    </div>

    <div class="controls-container">
      <div class="controls-section">
        <button
          class="control-btn"
          (click)="playPreviousMusic()"
          [disabled]="!hasPreviousMusic()"
          [class.disabled]="!hasPreviousMusic()"
          [attr.aria-label]="'Previous music'"
        >
          <em class="icon-liteGroup"></em>
        </button>
        <button
          class="control-btn rewind-15"
          (click)="rewind15()"
          [disabled]="isLocked && !currentMusic?.canPreview"
        >
          <em class="icon-litebackward-15"></em>
        </button>
        <button
          class="control-btn play-pause-btn"
          (click)="togglePlayPause()"
          aria-label="Play/Pause"
        >
          <span *ngIf="!isPlaying" class="play-icon">
            <em class="icon-liteplay"></em>
          </span>
          <span *ngIf="isPlaying" class="pause-icon">
            <em class="icon-litepause"></em>
          </span>
        </button>
        <button
          class="control-btn forward-15"
          (click)="fastForward15()"
          [disabled]="isLocked && !currentMusic?.canPreview"
        >
          <em class="icon-liteforward-15"></em>
        </button>
        <button
          class="control-btn"
          (click)="playNextMusic()"
          [disabled]="!hasNextMusic()"
          [class.disabled]="!hasNextMusic()"
          [attr.aria-label]="'Next music'"
        >
          <em class="icon-liteGroup1"></em>
        </button>
      </div>

      <div class="progress-section">
        <div class="time-display-left">{{ formatTime(currentTime) }}</div>
        <div class="progress-bar-container-minimized" (click)="seek($event)">
          <div
            class="progress-bar-minimized"
            [style.width.%]="getProgressPercent()"
            [style.background-color]="
              cs.isWhiteLabelWeb ? 'var(--configThemeColor)' : '#09c6da'
            "
          ></div>
        </div>
        <div class="time-display-right">{{ formatTime(duration) }}</div>
      </div>
    </div>

    <div class="control-group-right">
      <div class="speed-control" *ngIf="cs.isBrowser">
        <button class="control-btn speed-btn" (click)="toggleSpeedMenu()">
          <span class="speed-rate">{{ playbackRate }}x</span>
          <em class="icon-litechevron_down"></em>
        </button>
        <div class="speed-menu" *ngIf="showSpeedMenu">
          <button
            *ngFor="let rate of playbackRates"
            class="speed-option"
            [class.active]="rate === playbackRate"
            (click)="setPlaybackRate(rate)"
          >
            {{ rate }}x
          </button>
        </div>
      </div>

      <div class="volume-control">
        <button
          class="control-btn volume-btn"
          (click)="toggleVolumeSlider()"
          (contextmenu)="toggleMute(); $event.preventDefault()"
        >
          <em
            *ngIf="!isMuted && volume > Application.ZERO"
            class="icon-liteic-volume"
          ></em>
          <em
            *ngIf="isMuted || volume === Application.ZERO"
            class="icon-litespeaker-mute"
          ></em>
        </button>
        <div class="volume-slider-container" *ngIf="showVolumeSlider">
          <input
            type="range"
            class="volume-slider"
            [min]="Application.ZERO"
            [max]="Application.ONE"
            step="0.01"
            [value]="volume"
            (input)="onVolumeChange($event)"
            (click)="$event.stopPropagation()"
          />
        </div>
      </div>
      <button
        *ngIf="authService.isLogin"
        class="control-btn"
        (click)="maximizeModal()"
      >
        <em class="icon-liteenlarge"></em>
      </button>
    </div>
  </div>

  <!-- Mobile Minimized View -->
  <div
    class="minimized-player-mobile"
    [class.white-label-theme]="cs.isWhiteLabelWeb"
    *ngIf="isMobile"
    (click)="maximizeModal(); $event.stopPropagation()"
  >
    <div class="mobile-album-art">
      <img
        *ngIf="currentMusic?.previewImageUrl"
        [src]="currentMusic?.previewImageUrl"
        [alt]="currentMusic?.songTitle"
        class="album-art-small"
        appDisableRightClick
        appMobileOptimization
        [originalUrl]="currentMusic?.previewImageUrl"
        [format]="'webp'"
        loading="lazy"
        decoding="async"
      />
      <div
        class="skeleton-thumbnail album-art-small"
        *ngIf="!currentMusic?.previewImageUrl"
      >
        <div class="song-audio-icon-small">
          <em class="icon-litemusic-node-2"></em>
        </div>
      </div>
      <div class="lock-overlay" *ngIf="isLocked">
        <em class="icon-lock cursor-pointer" (click)="maximizeModal()"></em>
      </div>
    </div>

    <div class="mobile-track-title">
      {{ currentMusic?.songTitle }}
    </div>

    <button
      class="mobile-play-btn"
      (click)="togglePlayPause(); $event.stopPropagation()"
      aria-label="Play/Pause"
    >
      <span *ngIf="!isPlaying" class="play-icon">
        <em class="icon-liteplay"></em>
      </span>
      <span *ngIf="isPlaying" class="pause-icon">
        <em class="icon-litepause"></em>
      </span>
    </button>

    <div
      class="mobile-progress-bar"
      [style.width.%]="getProgressPercent()"
      [style.background-color]="
        cs.isWhiteLabelWeb ? 'var(--configThemeColor)' : '#09c6da'
      "
    ></div>
  </div>
</div>
